import React from 'react';
import { StarIcon } from 'lucide-react';
import { heroQuotes } from '../data/salesCopy';
export function SocialProofStrip() {
  return <section aria-label="Teacher quotes" className="w-full bg-night" data-id="element-216" data-mp="3fcrnc2m4kj0d">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-4 px-4 py-10 sm:px-5 sm:py-14 md:grid-cols-3 md:gap-6" data-id="element-217" data-mp="30p6fxwi7vxmn">
        {heroQuotes.map(quote => <figure key={quote.name} className="flex h-full flex-col rounded-2xl border border-line bg-panel p-5 sm:p-6" data-id="element-218" data-mp="35l51zdg2p3jw">
            <div className="flex items-center gap-0.5" aria-hidden="true" data-id="element-219" data-mp="2wnkzk16h517p">
              {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-gold text-gold" data-id="element-220" data-mp="2hrn46l4dk0wj" data-mpi={i} />)}
            </div>
            <blockquote className="mt-4 text-[15px] leading-relaxed text-cream-muted" data-id="element-221" data-mp="fy61lvv3pq8n">
              “{quote.quote}”
            </blockquote>
            <figcaption className="mt-auto pt-5 text-[11px] font-semibold uppercase tracking-[0.12em] text-gold" data-id="element-222" data-mp="kw7l2hwfvrkn">
              {quote.name} · {quote.role}
            </figcaption>
          </figure>)}
      </div>
    </section>;
}